import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-odd-tab-head" }
const _hoisted_2 = { class: "as-company" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "as-tab-btn-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "as-odd-tab-body" }
const _hoisted_9 = { class: "as-teambox-odds__column as-column-odds" }
const _hoisted_10 = { class: "as-column-row" }
const _hoisted_11 = { class: "as-column-row" }
const _hoisted_12 = { class: "as-teambox-odds__column as-column-odds" }
const _hoisted_13 = { class: "as-column-row" }
const _hoisted_14 = { class: "as-column-row" }
const _hoisted_15 = { class: "as-teambox-odds__column as-column-ft-ht" }
const _hoisted_16 = { class: "as-teambox-odds__column as-column-odds" }
const _hoisted_17 = { class: "as-column-row" }
const _hoisted_18 = { class: "as-column-row" }
const _hoisted_19 = { class: "as-teambox-odds__column as-teambox-odds__column-border as-column-location" }
const _hoisted_20 = { class: "as-teambox-odds__column as-column-odds" }
const _hoisted_21 = { class: "as-column-row" }
const _hoisted_22 = { class: "as-column-row" }

import type { IOddMatch, IItemString } from "~src/interfaces";
import { ref, computed, watch, onMounted } from "vue";
import { getOdds } from "~src/helpers/odd";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { usecommonStore } from "~src/stores/CommonStore";
import { useClickOutside } from "~src/utils/clickOutsideHelper";

const __default__ = {};

interface IProps {
  odd: IOddMatch[];
  oddOld: IOddMatch[];
  tabKey: number;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OddTab',
  props: {
    odd: {},
    oddOld: {},
    tabKey: {}
  },
  setup(__props: any) {

const matchDetailStore = useMatchDetailStore();
const commonStore = usecommonStore();

const props = __props;
const screenWidth = computed(() => matchDetailStore.getScreenWidth);

const refSelectCompany = ref<HTMLElement | null>(null);
const refCompanyActive = ref<HTMLElement | null>(null);

const isSelectCompany = ref(false);
const act = ref(false);

const gSportType = computed(() => commonStore.getSportType);

const crTitle = computed(() => {
  return gSportType.value === "football" ? "Phạt góc" : "Ném phạt";
});

const isFeaturedSports = computed(() => {
  return ['football', 'basketball'].includes(gSportType.value);
});
const company = ref<string>("21");

onMounted(() => {
  company.value = isFeaturedSports.value ? "21" : "2";
});

const tabs = computed(() => {
  const data = [
    {
      title: "Châu Á",
      key: "asia",
    },
    {
      title: "Châu Âu",
      key: "europe",
    },
    {
      title: "Tài xỉu",
      key: "over_under",
    },
  ] as Array<{
    title: string;
    key: string;
  }>;

  if (isFeaturedSports.value) {
    data.push({
      title: crTitle.value,
      key: "corner",
    });
  }

  return data;
});

const companies = computed(() => {
  const data = [
    {
      id: "2",
      logo: "https://cdn.lfastcdn.com/2024/08/8.png",
    },
    {
      id: "15",
      logo: "https://cdn.lfastcdn.com/2024/08/31.png",
    },
    {
      id: "3",
      logo: "https://cdn.lfastcdn.com/2024/08/3.png",
    },
    ...(isFeaturedSports.value ? [{
      id: "21",
      logo: "https://cdn.lfastcdn.com/2024/08/23.png",
    }] : []),
  ]

  return data;
})

const tabActive: IItemString = ref(["asia", "europe", "over_under", "corner"]);
const companyIds = computed(() => {
  return isFeaturedSports.value ? ["21", "2", "3", "15"] : ["2", "3", "15"];
});

const oddData = computed(() => {
  if (!props.odd) {
    return [] as IItemString;
  }

  let companyData = props.odd.find(
    (item: IOddMatch) => item.company_id === company.value
  );

  if (!companyData && !act.value) {
    for (const type of companyIds.value) {
      companyData = props.odd.find(
        (item: IOddMatch) => item.company_id === type
      );
      if (companyData) {
        company.value = type;
        break;
      }
    }
  }

  return getOdds(gSportType.value, props.odd, props.oddOld, company.value) as IItemString;
});

const companyActive = computed(() => {
  return companies.value.find((item: any) => item.id === company.value) as {
    id: string;
    logo: string;
  };
});

const changeTab = (tab: string) => {
  const datas = tabActive.value;
  const index = datas.indexOf(tab);

  if (index !== -1) {
    datas.splice(index, 1);
  } else {
    datas.push(tab);
  }

  tabActive.value = datas;
};

const selectCompany = (id: string) => {
  company.value = id;
  isSelectCompany.value = false;
  act.value = true;
};

const toggleSideCompany = () => {
  isSelectCompany.value = !isSelectCompany.value;
};

const clickOutsideCompany = () => {
  isSelectCompany.value = false;
};

useClickOutside([refCompanyActive, refSelectCompany], {
  handler: clickOutsideCompany,
  middleware: (event) => {
    return true;
  },
});

watch(oddData, (newValue) => {
  if (!newValue || Object.values(newValue).every(value => !value || value === "-")) {
    for (const type of companyIds.value) {
      if (type === company.value) continue;

      const newOdds = getOdds(gSportType.value, props.odd, props.oddOld, type) as IItemString;
      if (newOdds && Object.values(newOdds).some(value => value) && !Object.values(newOdds).every(value => !value || value === "-")) {
        setTimeout(() => {
          selectCompany(type);
        }, 1000);
        break;
      }
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-odd-tab", {
    'as-odd-tab-sm': screenWidth.value < 576,
  }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "as-name",
          onClick: toggleSideCompany,
          ref_key: "refCompanyActive",
          ref: refCompanyActive
        }, [
          (companyActive.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: companyActive.value.logo,
                alt: "odd"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "4",
            viewBox: "0 0 8 4",
            fill: "none"
          }, [
            _createElementVNode("path", {
              d: "M7.60738 0.173888C7.5558 0.121883 7.49443 0.0806058 7.42682 0.052437C7.35921 0.0242682 7.28669 0.00976562 7.21344 0.00976562C7.14019 0.00976562 7.06767 0.0242682 7.00006 0.052437C6.93245 0.0806058 6.87108 0.121883 6.8195 0.173888L4.2783 2.71508C4.22672 2.76709 4.16536 2.80837 4.09774 2.83653C4.03013 2.8647 3.95761 2.87921 3.88436 2.87921C3.81112 2.87921 3.73859 2.8647 3.67098 2.83653C3.60337 2.80837 3.542 2.76709 3.49042 2.71508L0.949227 0.173888C0.897646 0.121883 0.83628 0.0806058 0.768667 0.052437C0.701054 0.0242682 0.628532 0.00976562 0.555286 0.00976562C0.48204 0.00976562 0.409518 0.0242682 0.341905 0.052437C0.274292 0.0806058 0.212925 0.121883 0.161345 0.173888C0.0580045 0.277846 0 0.418472 0 0.565055C0 0.711637 0.0580045 0.852264 0.161345 0.956221L2.70809 3.50297C3.02019 3.81468 3.44326 3.98977 3.88436 3.98977C4.32547 3.98977 4.74853 3.81468 5.06064 3.50297L7.60738 0.956221C7.71072 0.852264 7.76873 0.711637 7.76873 0.565055C7.76873 0.418472 7.71072 0.277846 7.60738 0.173888Z",
              fill: "#01B243"
            })
          ], -1))
        ], 512),
        _withDirectives(_createElementVNode("ul", {
          ref_key: "refSelectCompany",
          ref: refSelectCompany
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companies.value, (company) => {
            return (_openBlock(), _createElementBlock("li", {
              key: company.id,
              onClick: ($event: any) => (selectCompany(company.id))
            }, [
              _createElementVNode("img", {
                src: company.logo,
                alt: "odd"
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4))
          }), 128))
        ], 512), [
          [_vShow, isSelectCompany.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tab.key
          }, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["as-tab-btn", {
            'as-active': tabActive.value.includes(tab.key),
            [`as-tab-btn-${tab.key}`]: true,
          }]),
              onClick: ($event: any) => (changeTab(tab.key))
            }, _toDisplayString(tab.title), 11, _hoisted_7)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(), _createElementBlock("div", {
        class: "as-teambox-odds",
        key: _ctx.tabKey
      }, [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["as-teambox-odds__row", { 'as-teambox-odds__row-asia': tabActive.value.includes('asia') }])
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-teambox-odds__column as-teambox-odds__column-border as-column-location" }, [
            _createElementVNode("span", null, "Châu Á")
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-teambox-odds__column as-column-ft-ht" }, [
            _createElementVNode("span", null, "HT"),
            _createElementVNode("span", null, "FT")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.asia_early_class_1)
              }, _toDisplayString(oddData.value.asia_early_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.asia_early_class_2)
              }, _toDisplayString(oddData.value.asia_early_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.asia_early_class_3)
              }, _toDisplayString(oddData.value.asia_early_3), 3)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.asia_run_class_1)
              }, _toDisplayString(oddData.value.asia_run_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.asia_run_class_2)
              }, _toDisplayString(oddData.value.asia_run_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.asia_run_class_3)
              }, _toDisplayString(oddData.value.asia_run_3), 3)
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-teambox-odds__row-asia--border-left" }, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-teambox-odds__row-asia--border-right" }, null, -1))
        ], 2), [
          [_vShow, tabActive.value.includes('asia')]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["as-teambox-odds__row", { 'as-teambox-odds__row-europe': tabActive.value.includes('europe') }])
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "as-teambox-odds__column as-teambox-odds__column-border as-column-location" }, [
            _createElementVNode("span", null, "Châu Âu")
          ], -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "as-teambox-odds__column as-column-ft-ht" }, [
            _createElementVNode("span", null, "HT"),
            _createElementVNode("span", null, "FT")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.eu_early_class_1)
              }, _toDisplayString(oddData.value.eu_early_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.eu_early_class_2)
              }, _toDisplayString(oddData.value.eu_early_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.eu_early_class_3)
              }, _toDisplayString(oddData.value.eu_early_3), 3)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.eu_run_class_1)
              }, _toDisplayString(oddData.value.eu_run_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.eu_run_class_2)
              }, _toDisplayString(oddData.value.eu_run_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.eu_run_class_3)
              }, _toDisplayString(oddData.value.eu_run_3), 3)
            ])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "as-teambox-odds__row-europe--border-left" }, null, -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "as-teambox-odds__row-europe--border-right" }, null, -1))
        ], 2), [
          [_vShow, tabActive.value.includes('europe')]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["as-teambox-odds__row", { 'as-teambox-odds__row-over_under': tabActive.value.includes('over_under') }])
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "as-teambox-odds__column as-teambox-odds__column-border as-column-location" }, [
            _createElementVNode("span", null, "Tài xỉu")
          ], -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(gSportType.value === 'football' ? 'HT' : 'SỚM'), 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "FT", -1))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.bs_early_class_1)
              }, _toDisplayString(oddData.value.bs_early_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.bs_early_class_2)
              }, _toDisplayString(oddData.value.bs_early_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.bs_early_class_3)
              }, _toDisplayString(oddData.value.bs_early_3), 3)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.bs_run_class_1)
              }, _toDisplayString(oddData.value.bs_run_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.bs_run_class_2)
              }, _toDisplayString(oddData.value.bs_run_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.bs_run_class_3)
              }, _toDisplayString(oddData.value.bs_run_3), 3)
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "as-teambox-odds__row-over_under--border-left" }, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "as-teambox-odds__row-over_under--border-right" }, null, -1))
        ], 2), [
          [_vShow, tabActive.value.includes('over_under')]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["as-teambox-odds__row", { 'as-teambox-odds__row-corner': tabActive.value.includes('corner') }])
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(crTitle.value), 1)
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "as-teambox-odds__column as-column-ft-ht" }, [
            _createElementVNode("span", null, "SỚM"),
            _createElementVNode("span", null, "FT")
          ], -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.cr_early_class_1)
              }, _toDisplayString(oddData.value.cr_early_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.cr_early_class_2)
              }, _toDisplayString(oddData.value.cr_early_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.cr_early_class_3)
              }, _toDisplayString(oddData.value.cr_early_3), 3)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.cr_run_class_1)
              }, _toDisplayString(oddData.value.cr_run_1), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.cr_run_class_2)
              }, _toDisplayString(oddData.value.cr_run_2), 3),
              _createElementVNode("span", {
                class: _normalizeClass(oddData.value.cr_run_class_3)
              }, _toDisplayString(oddData.value.cr_run_3), 3)
            ])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "as-teambox-odds__row-corner--border-left" }, null, -1)),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "as-teambox-odds__row-corner--border-right" }, null, -1))
        ], 2), [
          [_vShow, ['football', 'basketball'].includes(gSportType.value) && tabActive.value.includes('corner')]
        ])
      ]))
    ])
  ], 2))
}
}

})